// extracted by mini-css-extract-plugin
module.exports = {"noteWrapper":"Note_noteWrapper__3fK3j","icon":"Note_icon__3Cn8d","listWrapper":"Note_listWrapper__3ulxP","listItem":"Note_listItem__2zbf2"};